import { useEffect, useRef, useState } from 'react';

export const useElementOnScreen = (options) => {

  const containerRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  const callback = (entries) => {
    const [entry] = entries
    setIsVisible(entry.isIntersecting)
  }

  useEffect(() => {
    try {
      const o = new IntersectionObserver(callback, options)
      if (containerRef?.current) o.observe(containerRef.current)
      return () => {
        // eslint-disable-next-line
        if (containerRef?.current) o.unobserve(containerRef.current)
      }
    } catch (error) {

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef]);

  return [containerRef, isVisible]

}

// nvDr6zSuqPRXZ4hB34Yp
// cCuOqdtxWTB5AKdWWg0W